import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn, Clock } from 'lucide-react';
import authService from '../../services/authService';

const SessionExpired = ({ setIsAuthenticated }) => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  const hideOverlay = () => setIsVisible(false);

  const handleSessionExpiration = async () => {
    try {
      await authService.logout();
      sessionStorage.removeItem('user');
      setIsAuthenticated(false);
      document.cookie.split(';').forEach(cookie => {
        document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      });
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  // Call handleSessionExpiration when component mounts
  useEffect(() => {
    handleSessionExpiration();
    // Empty dependency array means this only runs once when mounted
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/40 p-4 dark:bg-black/70">
      <div className="w-full max-w-sm animate-slide-up rounded-xl bg-white p-8 text-center shadow-overlay ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-white/10" role="alertdialog" aria-modal="true" aria-labelledby="session-expired-title">
        <Clock className="mx-auto h-6 w-6 text-warning-500 dark:text-warning-400" strokeWidth={1.75} />
        <h2 id="session-expired-title" className="mt-4 text-base font-semibold text-gray-900 dark:text-gray-50">
          {t('Session Expired')}
        </h2>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {t('Your session has expired. Please log in again.')}
        </p>
        <Link
          to="/login"
          onClick={hideOverlay}
          className="btn btn-primary btn-lg mt-7 w-full"
        >
          <LogIn className="h-4 w-4" />
          {t('Go to Login')}
        </Link>
      </div>
    </div>
  );
};

export default SessionExpired;